import { render } from "./FormComapnyComponent.vue?vue&type=template&id=27a47730"
import script from "./FormComapnyComponent.vue?vue&type=script&lang=js"
export * from "./FormComapnyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__